import { Button, Col, Divider, Form, Input, Modal, Row, Table, notification } from "antd";
import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import DistributionDetail from "../../Components/distribuicao/detail";
import { getDistribution, getDistributions } from "../../API/StaticGetters";
import dayJS from "dayjs";
import axios from "axios";

const Autorizar = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalView, setModalView] = useState(false);
    const [distribution, setDistribution] = useState({});
    const [modalAprove, setModalAprove] = useState(false);
    const [typeForm, setTypeForm] = useState('')
    const [form] = Form.useForm();

    useEffect(() => {
        localStorage.setItem('title', 'Autorizar Distribuições');
        localStorage.setItem('type', '2')
        getData()
    }, [])

    const getData = async () => {
        setLoading(true)
        try {
            let dists = await getDistributions(2)
            setData(dists)
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            title: 'Referência',
            dataIndex: 'reference',
            key: 'reference',
            width: 150,
        },
        {
            title: 'Unidade Organica',
            dataIndex: 'unidade',
            key: 'unidade',
            render: (text, record) => (
                <p>{record.unit.name}</p>
            ),
        },
        {
            title: 'Período',
            dataIndex: 'periodo',
            key: 'periodo',
            width: 200,
            render: (text, record) => (
                <p>{record.period.name}</p>
            ),
        },
        {
            title: 'Data de Registo',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 200,
            render: (text, record) => (
                <p>{dayJS(record.created_at).format('DD/MM/YYYY HH:mm')}</p>
            ),
        },
        {
            title: 'Acções',
            key: 'action',
            width: 50,
            render: (text, record) => (
                <span className='flex justify-center items-center'>
                    <a onClick={() => handleView(record.id)}>
                        <FaEye
                            size={17}
                            color="#047d4b"
                        />
                    </a>
                </span>
            ),
        },
    ];

    const handleView = async (id) => {
        let dados = await getDistribution(id)
        setDistribution(dados)
        setModalView(true)
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const rowSelection = {
        selectedRowKeys,
        onChange: setSelectedRowKeys,
    };

    const handleAprove = (type) => {
        return () => {
            form.resetFields();
            if (selectedRowKeys.length === 0) {
                notification.error({
                    message: 'Sem Distribuições Selecionadas',
                    description: 'Selecione pelo menos uma distribuição para autorizar ou reprovar'
                });
                return;
            }
            switch (type) {
                case 1:
                    setTypeForm('Autorizar');
                    setModalAprove(true);
                    break;
                case 2:
                    setTypeForm('Reprovar');
                    setModalAprove(true);
                    break;
                default:
                    break;
            }
        }
    }

    const aproveProcess = async(values) => {
        setLoading(true)
        axios.put(
            localStorage.getItem('url') + '/api/distribution/manage/',
            {
                ids: selectedRowKeys,
                action: typeForm === 'Autorizar' ? "Autorizou Distribuição" : "Reprovou Distribuição",
                status: typeForm === 'Autorizar' ? 4 : 5,
                message: values.message || ''
            },
            {
                headers: {
                    'Authorization': 'Token ' + sessionStorage.getItem('token')
                }
            },
        ).then(() => {
            notification.success({
                message: 'Distribuições Atualizadas',
                description: 'Distribuições atualizadas com sucesso'
            });
            getData()
            setModalAprove(false)
        }).catch(() => {
            notification.error({
                message: 'Erro ao Atualizar Distribuições',
                description: 'Erro ao atualizar distribuições, tente novamente'
            });
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <div className='w-full flex flex-col px-5 py-4'>
            <p className="title-form">Distribuições Aguardando Autorização</p>
            <Table
                className='custom-table mt-2'
                size="small"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={{ defaultPageSize: 5, showSizeChanger: true, pageSizeOptions: ['5', '10', '15', '50', '100'] }}
                locale={{
                    emptyText: 'Sem distribuições aguardando aprovação'
                }}
                rowKey={record => record.id}
                rowSelection={rowSelection}
                footer={() => {
                    return (
                        <div className="flex flex-row justify-between items-center w-full">
                            <p className="text" style={{ margin: 0 }}>{selectedRowKeys.length} Distribuições Selecionados</p>
                            <div className="flex flex-row justify-end gap-3 ">
                                <Button
                                    className="button-in"
                                    onClick={handleAprove(1)}
                                >
                                    Autorizar Selecionados
                                </Button>
                                <Button
                                    className="button-out"
                                    onClick={handleAprove(2)}
                                >
                                    Reprovar Selecionados
                                </Button>
                            </div>
                        </div>
                    )

                }}
            />
            <Modal
                title={<p className='title'>DETALHES DA DISTRIBUIÇÃO</p>}
                open={modalView}
                onOk={() => setModalView(false)}
                onCancel={() => setModalView(false)}
                footer={null}
                width={700}
            >
                <DistributionDetail dados={distribution} />
            </Modal>
            <Modal
                title={<p className='title'>{typeForm} Distribuições</p>}
                open={modalAprove}
                onOk={() => setModalAprove(false)}
                onCancel={() => setModalAprove(false)}
                footer={null}
                width={600}
            >
                <div className="flex flex-col gap-3">
                    <Form form={form} layout="vertical" onFinish={aproveProcess}>
                        <p className="text">Tem certeza que deseja {typeForm.toLowerCase()} as distribuições selecionadas?</p>
                        {typeForm === 'Reprovar' && (
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item
                                        label={<p className='label-input'>Motivo da Reprovação</p>}
                                        labelCol={{ span: 24 }}
                                        name="message"
                                        className='input'
                                        rules={[{ required: true, message: 'Por favor insira o motivo!' }]}
                                    >
                                        <Input.TextArea
                                            placeholder="Motivo da Reprovação"
                                            className='input-form'
                                            style={{ borderRadius: '0px' }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                        <div className="flex flex-row justify-end gap-3 mt-2">
                            <Button
                                className="button-out"
                                onClick={() => setModalAprove(false)}
                            >
                                Cancelar
                            </Button>
                            <Button
                                className="button-in"
                                htmlType="submit"
                            >
                                {typeForm}
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal>
        </div>
    )
}

export default Autorizar;